import React from 'react';
import pitsburg from '../../Assests/Events/pitburgModal.svg';

function EventInsidePitsburg() {

  const isMobile = window.innerWidth <= 768;

  return (
    <>
      <div className="mt-5 pt-5">
        <div className="mx-2 mx-md-5 text-center">
          <img className="p-2 w-100 pitsburg-image-inside" src={pitsburg} alt="pitsburg" />
        </div>

        <div className="mx-2 mx-md-5 mt-2">
          <div className="pitsburg-headline-inside-text">
            One-Day Symposium on P5 Healthcare with Multi-Omics and AI-Driven Personalization
          </div>

    
          {isMobile ? (
            <div style={{ display: 'flex', flexDirection: 'column', gap: '8px', marginTop: '8px' }}>
              <div style={{ marginBottom: '8px' }}>
                <span className="Finished-status-pill py-2 px-4">Finished</span>
              </div>
              <div style={{ display: 'flex', flexDirection: 'row', gap: '8px' }}>
                <div className="time-status-pill py-2 px-2">
                  <span className="material-symbols-outlined me-1" style={{ fontSize: '18px' }}>
                    schedule
                  </span>
                  8:00 AM - 8:00 PM
                </div>
                <div className="time-status-pill py-2 px-4">
                  <span className="material-symbols-outlined me-1" style={{ fontSize: '18px' }}>
                    calendar_month
                  </span>
                  1st May, 2025
                </div>
              </div>
            </div>
          ) : (
            // Desktop layout: All in a row
            <div style={{ display: 'flex', alignItems: 'center', gap: '8px', marginTop: '8px' }}>
              <div style={{ marginRight: '8px' }}>
                <span className="Finished-status-pill py-2 px-4">Finished</span>
              </div>
              <div style={{ display: 'flex', gap: '8px' }}>
                <div className="time-status-pill py-2 px-4">
                  <span className="material-symbols-outlined me-1" style={{ fontSize: '18px' }}>
                    schedule
                  </span>
                  8:00 AM - 8:00 PM
                </div>
                <div className="time-status-pill py-2 px-4">
                  <span className="material-symbols-outlined me-1" style={{ fontSize: '18px' }}>
                    calendar_month
                  </span>
                  1st May, 2025
                </div>
              </div>
            </div>
          )}

          {/* <div
            className="d-inline-flex primary-btn py-2 px-4 careers-contact-us contact-us align-items-center mt-4"
            onClick={() =>
              window.open(
                'https://www.health.pitt.edu/pitt-med-ai-transforming-global-health-symposium?utm_source=hsstratcomm_eblast&utm_medium=email&utm_campaign=ai_symposium_25&utm_content=invitation#Details',
                '_blank'
              )
            }
            style={{ cursor: 'pointer' }}
          >
            <div>Join Now</div>
		    <span className="material-symbols-outlined ms-1">arrow_right_alt</span>
          </div> */}

          {/* Rest of the component remains unchanged */}
          <div className="mt-5">
            <div className="event-inside-heading">Venue :</div>
            <div className="event-inside-text">
              The University Club, University of Pittsburgh, Oakland Campus
            </div>
          </div>
          <div className="mt-3">
            <div className="event-inside-heading">Event Details:</div>
            <div className="event-inside-text-sub-head mt-2">
              ⭐ Launch of the 1 million Precision Medicine Initiative (1M-PMI)
            </div>
            <div className="event-inside-text-sub mt-1">
              Vizzhy Inc. and the University of Pittsburgh are proud to announce the Global 1 Million Multi-Omics Precision Medicine Initiative (1M-PMI) - a transformative commitment to collect and analyze multi-omics and longitudinal health data across 1 million individuals worldwide.
            </div>
          </div>
          <div className="mt-3">
            <div className="event-inside-text-sub-head">
              ⭐ Inauguration of the Pitt-Vizzhy Longevity Labs
            </div>
            <div className="event-inside-text-sub mt-1">
              In collaboration with the Illumina Inc., we are proud to launch a next-generation multi-omics lab headquatered in Pittsburgh. This center of excellence will deliver advanced omics services - genomics, transcriptomics, proteomics, metabolomics, microbiomics and phenomics - to healthcare system across the US and globally.
            </div>
          </div>
          <div className="mt-3">
            <div className="event-inside-text-sub-head">
              ⭐ Global Launch of GAINMED: The AI Engine of Precision Health
            </div>
            <div className="event-inside-text-sub mt-1">
              Developed by Vizzhy Inc., GAINMED is a pioneering digital platform powered by AI, Multi-Omics and Digital Biomarkers to deliver personalised insights for patients and clinicians. GAINMED represents the shift from reactive medicine to real-time health intelligence, tracking physiological, behavioral, environmental and biological data to guide early intervention and personalised prevention.
            </div>
          </div>
          <div className="mt-2">
            <div className="event-inside-heading">Keynote Speaker:</div>
            <div className="event-inside-text-sub-head mt-1">Prof. LEROY HOOD</div>
            <div className="event-inside-text-sub mt-1">
              Buck Institute for Research on Aging | Institute for Systems Biology | Phenome Health Inc.
            </div>
          </div>
          <div className="mt-2">
            <div className="event-inside-heading">Symposium Highlights:</div>
            <div className="event-inside-text-sub mt-2">
              <ul>
                <li>Global thought leaders on AI + Longevity + Systems Medicine</li>
                <li>Live demos of real-time multiomics diagnostics</li>
                <li>Launch of Korea and Anatolia. P4 Medicine Initiatives.</li>
                <li>Ethical, social and economic challenges in implementing P5 Care.</li>
                <li>Talks by Illumina, Buck Institute, Microsoft, LTIMindtree, Yotta, and top academic leaders</li>
              </ul>
            </div>
          </div>
          <div className="mt-2">
            <div className="event-inside-heading">Distinguished Speakers:</div>
            <div className="event-inside-text-sub mt-2">
              <ul>
                <li>Prof. Adil Mardinoglu</li>
                <li>Dr. Fiona Kaper</li>
                <li>Craig Mundie</li>
                <li>Prof. Nathan Price</li>
                <li>Dr. Vishnuvardhan Srinivasulu</li>
                <li>Prof. Hooman Rashidi</li>
                <li>Prof. Chandan Sen</li>
                <li>Nachiket Deshpande</li>
                <li>Sunil Gupta</li>
                <li>Prof. Vivek Goswami</li>
                <li>Prof. Mark Geraci</li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </>
  );
}

export default EventInsidePitsburg;